import { Component, OnInit } from '@angular/core';
import { NavigationService } from './navigation.service';

@Component({
	selector: 'navigation',
	templateUrl: './navigation.component.html',
	styleUrls: ['./navigation.component.css']
})
export class NavigationComponent implements OnInit {
	display: any[] = [];
	navigation: any[] = [];

	constructor(
		private navigationService: NavigationService
	) {
		this.navigation = this.navigationService.getNavigation();
		this.navigationService.navigationChange.subscribe(navigation => this.navigation = navigation);
	}

	ngOnInit() { }

	toggleHiddeItems(i, j) {
		for (let key in this.display) {
			let value = this.display[key];
			let myI = key.split("-")[0];
			let myJ = key.split("-")[1];
			if (String(i) != String(myI) || (myJ.length > 0 && String(j) != String(myJ))) {
				this.display[key] = 0;
			}
		}
		this.display[i + '-' + j] = !this.display[i + '-' + j]
	}

	toggleHiddeAllItems() {
		for (let key in this.display) {
			this.display[key] = 0;
		}
	}
}
